var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('el-checkbox',{attrs:{"disabled":_vm.getAuthShow()},model:{value:(_vm.zdItem.isChecked),callback:function ($$v) {_vm.$set(_vm.zdItem, "isChecked", $$v)},expression:"zdItem.isChecked"}},[_vm._v(_vm._s(_vm.zdItem.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }